module.exports = __webpack_public_path__ + "static/mountains-a3868bac134714ae4b6efbe515028f3e.svg";